import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

type Account = {
  id: number;
  guid: string;
  name: string;
};

type GetUserAccountsResponse = {
  accounts: Account[];
};

// GET /api/v2/user_accounts
export function getUserAccounts() {
  return axios.get<GetUserAccountsResponse>('/api/v2/user_accounts');
}

export function useGetUserAccounts(userId?: number) {
  return useQuery({
    queryKey: ['user_accounts', userId],
    queryFn: () => getUserAccounts().then(response => response.data),
    enabled: Boolean(userId),
    refetchOnWindowFocus: false
  });
}
